module.exports = __webpack_public_path__ + "static/not-found-c92171f78ce411b7475374758d12f7b2.svg";